import { AgencyDtoDto } from "../app/model/api/types/dto/agencyDto";

export class AgencyViewModel {
  id?: string | null;
  description: string | null;
  name: string | null;
  isActive?: boolean | null;
  sortValue: number | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    sortValue: number | null,
    isActive?: boolean | null,
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.isActive = isActive;
    this.sortValue = sortValue;
  }

  toDto(): AgencyDtoDto {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      isActive: this.isActive,
      sortValue: this.sortValue,
    };
  }

  mapFromDto(dto: AgencyDtoDto): void {
    this.id = dto.id;
    this.isActive = dto.isActive || true;
    this.description = dto.description;
    this.name = dto?.name;
    this.sortValue = dto.sortValue;
  }
}
